import { Field } from 'factorial-form'
import { DataSchemaItemFragment } from 'generated/resources/graphql'
import { uniqBy } from 'lodash'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

interface Props {
  dataSchemaItem: DataSchemaItemFragment
  field: Field
}

export const StringField = observer(({ dataSchemaItem, field }: Props) => {
  const allowedValues = dataSchemaItem.allowedValues ?? []

  if (allowedValues.length > 0) {
    const sortedAllowedValues = uniqBy([...allowedValues], 'key').sort((a, b) =>
      a.value.localeCompare(b.value)
    )
    return (
      <Selector.Popover
        blankLabel={i18n.t('employee_form.payroll_data.select_an_option')}
        placeholder={i18n.t('employee_form.payroll_data.select_an_option')}
        searchPlaceholder={dataSchemaItem.label}
        inputStyle="badge"
        label={dataSchemaItem.label}
        onChange={(newValue) => field.set(newValue ? String(newValue) : undefined)}
        value={[field.value]}
        warning=""
        isMultiSelect={false}
      >
        {sortedAllowedValues.map((allowedValue) => (
          <Selector.Option
            key={allowedValue.key}
            value={allowedValue.key}
            label={allowedValue.value}
            searchValue={allowedValue.value}
          >
            {allowedValue.value}
          </Selector.Option>
        ))}
      </Selector.Popover>
    )
  }

  return (
    <TextField
      label={dataSchemaItem.label}
      placeholder={dataSchemaItem.label}
      onChange={(newValue) => field.set(String(newValue))}
      value={field.value}
    />
  )
})
